document.body.style.setProperty('--device-height', window.innerHeight + "px");

/* Labely Hack */
window.addEventListener("variant:change", function(e) {
  const variantId = e.detail.variant.id;

  const labelyContainers = document.querySelectorAll(".Stocktime__Delivery");
  for(const labelyContainer of labelyContainers) {
    const fields = labelyContainer.querySelectorAll(".Stocktime__Delivery--fields");

    for(const field of fields) {
      if(field.dataset.variant == variantId) {
        field.style.display = "unset";
      } else {
        field.style.display = "none";
      }
    }
  }
});

/* Coupon Code */
class CouponCode extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const coupon = this.dataset.code;
    const tooltip = document.querySelector('.coupon-tooltip');

    const animation = [
      { opacity: 0, transform: "translate(-50%, -100%)" },
      { opacity: 1, transform: "translate(-50%, 100%)" },
      { opacity: 1, transform: "translate(-50%, 100%)" },
      { opacity: 1, transform: "translate(-50%, 100%)" },
      { opacity: 1, transform: "translate(-50%, 100%)" },
      { opacity: 1, transform: "translate(-50%, 100%)" },
      { opacity: 0, transform: "translate(-50%, -100%)" },
    ];

    const animationTiming = {
      duration: 2000,
      iterations: 1,
    };

    if(coupon) {
      this.addEventListener('click', function() {
        navigator.clipboard.writeText(coupon);
        tooltip.animate(animation, animationTiming);
      });
    }
    else {
      console.log("ERROR: Coupon not found.")
    }
  }
}

customElements.define('coupon-code', CouponCode);

/* Download Button */
document.addEventListener('DOMContentLoaded', function() {
  const content = document.querySelector('.download-button'); 
  if(content) {
    content.addEventListener('click', function() { 
      window.print(); 
    }); 
    window.addEventListener("afterprint", () => self.close); 
  }
}); 

/* Hide menu and search bar when scrolling down and show when scrolling up */
window.addEventListener('DOMContentLoaded', function() {
  const menu = document.querySelector('.header__primary-nav--desktop');
  const search = document.querySelector('.header__search--container');

  const collectionFilterMobile = document.querySelector('.collection--toolbar__mobile .collection--toolbar__upper');

  let scrollPositionTemp = 0;

  const event = new Event("menu:appeared");

  document.body.style.setProperty('--menu-height', `${menu.getBoundingClientRect().height}px`);
  document.body.style.setProperty('--search-height', `${search.getBoundingClientRect().height}px`);

  window.addEventListener('scroll', function() {
    document.body.style.setProperty('--menu-height', `${menu.getBoundingClientRect().height}px`);
    document.body.style.setProperty('--search-height', `${search.getBoundingClientRect().height}px`);
    
    if(window.scrollY > scrollPositionTemp) {
      /* Going down */
      menu.classList.add('hide');
      search.classList.add('hide');
      if(collectionFilterMobile) {
        collectionFilterMobile.style.setProperty('--mobile-top', 'calc(var(--header-height) + var(--announcement-bar-height))');
      }
    }
    else if (window.scrollY < scrollPositionTemp) {
      /* Going up */
      document.dispatchEvent(event);
      menu.classList.remove('hide');
      search.classList.remove('hide');
      if(collectionFilterMobile) {
        collectionFilterMobile.style.setProperty('--mobile-top', 'calc(var(--header-height) + var(--announcement-bar-height) + var(--search-height))');
      }
    }

    if(window.scrollY == 0) {
      menu.classList.remove('hide');
      search.classList.remove('hide');
    }
    scrollPositionTemp = window.scrollY;
  });
});
/* Sticky Filter */
window.addEventListener('DOMContentLoaded', function() {
  const filter = document.querySelector('.collection--toolbar__upper:not(.fixed)');
  const sticky = document.querySelector('.collection--toolbar__upper.fixed');
  if(filter && sticky) {
    const header = document.querySelector('header');

    if(filter.getBoundingClientRect().top <= header.getBoundingClientRect().height) {
      sticky.classList.add('active');
    }
    else {
      sticky.classList.remove('active');
    }

    window.addEventListener('scroll', function() {
      if(filter.getBoundingClientRect().top <= header.getBoundingClientRect().height) {
        sticky.classList.add('active');
      }
      else {
        sticky.classList.remove('active');
      }
    });
  }
});

/* Collection Pagination */
window.addEventListener("popstate", (event) => {
  const sectionId = document.querySelector('.shopify-section--main-collection').getAttribute('id').replace('shopify-section-', ''), url = new URL(window.location.href);
  url.searchParams.set("section_id", sectionId);
  const button = document.querySelector(`[href="${window.location.href.split('www.solfelt.nl')[1]}"]`);
  button.dispatchEvent(new CustomEvent("facet:asd", {
    bubbles: true,
    detail: {
      url
    }
  }));
});

/* Newsletter Form */
if(localStorage.getItem('newsletterId')) {
  const url = window.location.href;
  const alreadySubscribedElement = document.querySelector(`#${localStorage.getItem('newsletterId')} .form--already-subscribed`);

  if(url.includes('form_type=customer')) {
    alreadySubscribedElement.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const newsletters = document.querySelectorAll('.contact-form');

  for(const newsletter of newsletters) {
    newsletter.addEventListener('submit', function() {
      localStorage.setItem('newsletterId', newsletter.getAttribute('id'));
    });
  }
});

class InspirationSlider extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.setupGlobals();
      this.doubleItems();
      this.initItems();
      this.checkSlider();
      this.sliderEvents();
      window.addEventListener('resize', function() {
        this.checkSlider();
      }.bind(this));
    }
  
    setupGlobals() {
      this.container = this.querySelector('.inspiration-slider--container');
      this.slider = this.querySelector('.inspiration-slider');
      this.items = this.querySelectorAll('.inspiration-slider--item');
      this.itemsCount = this.items.length;
      this.navContainer = this.querySelector('.inspiration-slider--navigation');
      this.navCurrent = this.querySelector('.inspiration-slider--current-position');
      this.infiniteScroll = this.dataset.infiniteScroll == "" ? true : false;
      this.align = this.dataset.align ? this.dataset.align == "center" ? "center" : "left" : "left";
      this.gap = this.dataset.gap ? parseInt(this.dataset.gap) : 0;
      this.selectedIndex = 0;
      this.currentIndex = 0;
      this.positions = [];
      this.mouseDown = false;
      this.widths = [];
      this.visibleItems = [];
      this.dragAmount = 0;
    }
  
    doubleItems() {
      this.container.innerHTML += this.container.innerHTML;
      this.items = this.querySelectorAll('.inspiration-slider--item');
    }
  
    checkSlider() {
      if(window.getComputedStyle(this.container, '::before').content == '"rao-slider"') {
        this.classList.add('active');
        this.selectItem(this.selectedIndex);
      }
      else {
        this.classList.remove('active');
      }
      for(let i = this.items.length / 2; i < this.items.length; i++) {
        this.items[i].classList.add('inspiration-slider--extra-item');
      }
    }
  
    initItems() {
      let leftAmount = this.items[0].getBoundingClientRect().width;
      this.items[0].style.setProperty('--left-amount', "0px");
      this.items[0].dataset.leftAmount = 0;
      this.positions[0] = 0;
      this.widths[0] = this.items[0].getBoundingClientRect().width;
      for(let i = 1; i < this.items.length; i++) {
        if(window.innerWidth < 699) {
          this.items[i].style.setProperty('--left-amount', `${i * window.innerWidth}px`);
          this.items[i].dataset.leftAmount = i * window.innerWidth;
        }
        else {
          this.items[i].style.setProperty('--left-amount', `${leftAmount + this.gap}px`);
          this.items[i].style.width = this.items[i].getBoundingClientRect().width + "px";
          this.items[i].dataset.leftAmount = leftAmount + this.gap;
        }
        
        this.positions[i] = i;
        this.widths[i] = this.items[i].getBoundingClientRect().width;
        leftAmount += this.items[i].getBoundingClientRect().width + this.gap;
      }
    }
  
    sliderEvents() {
      const nextButton = this.querySelector('.inspiration-slider--next');
      const prevButton = this.querySelector('.inspiration-slider--previous');
  
      nextButton.addEventListener('click', function() {
        this.selectedIndex++;
        if(this.selectedIndex == this.items.length) {
          this.selectedIndex = 0;
        }
        this.selectItem(this.selectedIndex);
      }.bind(this));
  
      prevButton.addEventListener('click', function() {
        this.selectedIndex--;
        if(this.selectedIndex < 0) {
          this.selectedIndex = this.items.length - 1;
        }
        this.selectItem(this.selectedIndex);
      }.bind(this));
  
      this.slider.addEventListener('mousedown', function(e) {
        this.mouseDownFn(e);
      }.bind(this));
  
      this.slider.addEventListener('touchstart', function(e) {
        this.touchDownFn(e);
      }.bind(this));
  
      this.slider.addEventListener('mousemove', function(e) {
        this.mouseMoveFn(e);
      }.bind(this));
  
      this.slider.addEventListener('touchmove', function(e) {
        this.touchMoveFn(e);
      }.bind(this));
  
      this.slider.addEventListener('mouseup', function() {
        this.mouseUpFn();
      }.bind(this));
  
      this.slider.addEventListener('mouseout', function() {
        this.mouseUpFn();
      }.bind(this));
  
      this.slider.addEventListener('touchend', function() {
        this.mouseUpFn();
      }.bind(this));
  
      this.slider.addEventListener('touchcancel', function() {
        this.mouseUpFn();
      }.bind(this));
    }
  
    mouseDownFn(e) {
      if(this.classList.contains('active')) {
        this.mouseDown = true;
        this.mouseDownPosition = e.clientX;
        this.container.style.setProperty('--moving-transform-amount', `${window.innerWidth / 2 - (parseInt(this.items[this.selectedIndex].dataset.leftAmount) + this.items[this.selectedIndex].getBoundingClientRect().width / 2)}px`);
        this.classList.add('moving');
        this.tempSelectedIndex = this.selectedIndex;
        this.movedWidth = 0;
      }
    }
  
    touchDownFn(e) {
      if(this.classList.contains('active')) {
        this.mouseDown = true;
        this.mouseDownPosition = e.changedTouches[0].clientX;
        this.container.style.setProperty('--moving-transform-amount', `${window.innerWidth / 2 - (parseInt(this.items[this.selectedIndex].dataset.leftAmount) + this.items[this.selectedIndex].getBoundingClientRect().width / 2)}px`);
        this.classList.add('moving');
        this.tempSelectedIndex = this.selectedIndex;
        this.movedWidth = 0;
      }
    }
  
    mouseMoveFn(e) {
      if(this.mouseDown) {
        this.moveAmount = -1 * (this.mouseDownPosition - e.clientX);
        this.container.style.setProperty('--moving-transform-amount', `${window.innerWidth / 2 - (parseInt(this.items[this.selectedIndex].dataset.leftAmount) + this.items[this.selectedIndex].getBoundingClientRect().width / 2) + this.moveAmount}px`);
        
        if(this.items[this.tempSelectedIndex].getBoundingClientRect().left > window.innerWidth / 2) {
          this.tempSelectedIndex--;
          if(this.tempSelectedIndex < 0) {
            this.tempSelectedIndex = this.items.length - 1;
          }
          this.navCurrent.innerText = this.navCurrent.innerText = (this.tempSelectedIndex - parseInt(this.tempSelectedIndex / this.itemsCount) * this.itemsCount) + 1;
          this.arrange(this.tempSelectedIndex);
        }
  
        if(this.items[this.tempSelectedIndex].getBoundingClientRect().right + this.gap < window.innerWidth / 2) {
          this.tempSelectedIndex++;
          if(this.tempSelectedIndex == this.items.length) {
            this.tempSelectedIndex = 0;
          }
          this.navCurrent.innerText = this.navCurrent.innerText = (this.tempSelectedIndex - parseInt(this.tempSelectedIndex / this.itemsCount) * this.itemsCount) + 1;
          this.arrange(this.tempSelectedIndex);
        }
      }
    }
  
    touchMoveFn(e) {
      if(this.mouseDown) {
        this.moveAmount = -1 * (this.mouseDownPosition - e.changedTouches[0].clientX);
        this.container.style.setProperty('--moving-transform-amount', `${window.innerWidth / 2 - (parseInt(this.items[this.selectedIndex].dataset.leftAmount) + this.items[this.selectedIndex].getBoundingClientRect().width / 2) + this.moveAmount}px`);
        
        if(this.items[this.tempSelectedIndex].getBoundingClientRect().left > window.innerWidth / 2) {
          this.tempSelectedIndex--;
          if(this.tempSelectedIndex < 0) {
            this.tempSelectedIndex = this.items.length - 1;
          }
          this.navCurrent.innerText = this.navCurrent.innerText = (this.tempSelectedIndex - parseInt(this.tempSelectedIndex / this.itemsCount) * this.itemsCount) + 1;
          this.arrange(this.tempSelectedIndex);
        }
  
        if(this.items[this.tempSelectedIndex].getBoundingClientRect().right + this.gap < window.innerWidth / 2) {
          this.tempSelectedIndex++;
          if(this.tempSelectedIndex == this.items.length) {
            this.tempSelectedIndex = 0;
          }
          this.navCurrent.innerText = this.navCurrent.innerText = (this.tempSelectedIndex - parseInt(this.tempSelectedIndex / this.itemsCount) * this.itemsCount) + 1;
          this.arrange(this.tempSelectedIndex);
        }
      }
    }
  
    mouseUpFn() {
      if(this.mouseDown) {
        this.mouseDown = false;
        this.classList.remove('moving');
        this.selectedIndex = this.tempSelectedIndex;
        this.selectItem(this.selectedIndex);
      }
    }
  
    selectItem(index) {
      this.arrange(this.selectedIndex);
      if(this.align == "center") {
        this.container.style.setProperty('--transform-amount', `calc(50% - (${this.items[index].style.getPropertyValue('--left-amount')} + ${this.items[index].getBoundingClientRect().width / 2}px))`);
      }
      else {
        this.container.style.setProperty('--transform-amount', `${-1 * parseInt(this.items[index].style.getPropertyValue("--left-amount"))}px`);
      }
  
      this.navCurrent.innerText = (this.selectedIndex - parseInt(this.selectedIndex / this.itemsCount) * this.itemsCount) + 1;
    }
  
    arrange(index) {
      const findIndex = (element) => element == index;
      /* Left Side */
      let remainingSpace = window.innerWidth / 2 - this.items[index].getBoundingClientRect().width / 2;
      if(this.positions.findIndex(findIndex) != 0) {
        for(let i = this.positions.findIndex(findIndex) - 1; i >= 0; i--) {
          remainingSpace -= this.items[this.positions[i]].getBoundingClientRect().width + this.gap;
        }
      }
      
      while(remainingSpace > 0) {
        remainingSpace -= this.items[this.positions[this.items.length - 1]].getBoundingClientRect().width;
        this.items[this.positions[this.items.length - 1]].style.setProperty('--left-amount', `${parseInt(this.items[this.positions[0]].dataset.leftAmount) - this.gap - this.items[this.positions[this.items.length - 1]].getBoundingClientRect().width}px`);
        this.items[this.positions[this.items.length - 1]].dataset.leftAmount = parseInt(this.items[this.positions[0]].dataset.leftAmount) - this.gap - this.items[this.positions[this.items.length - 1]].getBoundingClientRect().width;
        this.positions.unshift(this.positions[this.positions.length - 1]);
        this.positions.splice(this.positions.length - 1, 1);
      }
  
      /* Right Side */
      remainingSpace = window.innerWidth / 2 - this.items[index].getBoundingClientRect().width / 2 + this.gap;
      if(this.positions.findIndex(findIndex) != this.items.length - 1) {
        for(let i = this.positions.findIndex(findIndex) + 1; i < this.items.length; i++) {
          remainingSpace -= this.items[this.positions[i]].getBoundingClientRect().width + this.gap;
        }
      }
      
      while(remainingSpace > 0) {
        remainingSpace -= this.items[this.positions[0]].getBoundingClientRect().width;
        this.items[this.positions[0]].style.setProperty('--left-amount', `${parseInt(this.items[this.positions[this.items.length - 1]].dataset.leftAmount) + this.items[this.positions[this.items.length - 1]].getBoundingClientRect().width + this.gap}px`);
        this.items[this.positions[0]].dataset.leftAmount = parseInt(this.items[this.positions[this.items.length - 1]].dataset.leftAmount) + this.items[this.positions[this.items.length - 1]].getBoundingClientRect().width + this.gap;
        this.positions.push(this.positions[0]);
        this.positions.splice(0, 1);
      }
    }
  }
  
  customElements.define('inspiration-slider', InspirationSlider);

document.addEventListener('DOMContentLoaded', function() {
  
});

async function getAuth() {
  /*console.log("Starting authentication process...");
  const response = await fetch("https://www.solfelt.nl/apps/get-code", {
    method: "POST",
    body: "access"
  });

  const auth = await response.text();
  console.log("Received auth token, testing it...");
  testAuth(auth);*/
}

async function newAuth(oldAuth) {
  const response = await fetch("https://www.solfelt.nl/apps/get-code", {
    method: "POST",
    body: `error:${oldAuth}`
  });

  const auth = await response.text();
  testAuth(auth);
}

async function testAuth(auth) {
  console.log("Testing auth token...");
  const response = await fetch("https://www.feedbackcompany.com/api/v2/widgets", {
    method: "POST",
    headers: {
      "Authorization": "Bearer " + auth,
    },
    body: '{"type":"bar"}',
  });
  
  const widgetInfo = await response.json();
  console.log("Widget info response:", widgetInfo);
  
  if(widgetInfo.success) {
    if(widgetInfo.widget) {
      console.log("Widget found, fetching review data...");
      /* Get Data */
      const widgetResponse = await fetch(`https://www.feedbackcompany.com/api/v2/widgets/${widgetInfo.widget.uuid}/data?embed_code_version=1.2.1`,{
        method: "GET"
      });
      
      const reviewData = await widgetResponse.json();
      console.log("Review data received:", reviewData);
      localStorage.setItem('reviewData', JSON.stringify(reviewData.data.shop));
      window.reviewAppData = reviewData.data.shop;
    }
    else {
      console.log("No widget found, using cached data...");
      window.reviewAppData = JSON.parse(localStorage.getItem('reviewData'));
    }
    window.reviewAuth = auth;
    const event = new Event("access-granted");

    // Listen for the event.
    window.addEventListener(
      "access-granted",
      (e) => {
        console.log("Access granted event triggered");
      },
      false,
    );

    // Dispatch the event.
    window.dispatchEvent(event);
  }
  else {
    console.log("Auth test failed, requesting new token...");
    newAuth(auth);
  }
}

//getAuth();

/* Feedback Reviews */
window.addEventListener('DOMContentLoaded', async function() {
  console.log("DOM loaded, checking for review sections...");
  const reviewSections = document.querySelectorAll('.rao-reviews--section');
  console.log("Found review sections:", reviewSections.length);
  
  window.addEventListener('access-granted', async function() {
    console.log("Access granted event received, processing reviews...");
    if (reviewSections.length > 0) {
      console.log("Fetching reviews with auth token:", window.reviewAuth);
      response = await fetch(`https://www.feedbackcompany.com/api/v2/review/?access_token=${window.reviewAuth}`, {});
      const reviews = await response.json();
      console.log("Reviews response:", reviews);
      let actualReviews = { reviews: [] };

      /* Check if we got the reviews */
      if (reviews.reviews) {
        console.log("Processing reviews...");
        /* Shuffle the reviews */
        const shuffledReviews = reviews.reviews.filter(r => r.total_score >= 4).sort(() => Math.random() - 0.5);
        let counter = 0;

        /* Save the first 8 random reviews in local storage. */
        for (let i = 0; i < shuffledReviews.length; i++) {
          if (counter == 8) break;
          actualReviews.reviews.push(shuffledReviews[i]);
          counter++;
        }

        localStorage.setItem('actualReviews', JSON.stringify(actualReviews));
      } else {
        /* We don't got the reviews */
        /* Get the first 8 reviews from local storage. */
        actualReviews = JSON.parse(localStorage.getItem('actualReviews'));
      }

      for (const reviewSection of reviewSections) {
        const reviewContainer = reviewSection.querySelector('.rao-reviews--container');
        const reviewAverage = reviewSection.querySelector('.rao-reviews--average-score');
        const reviewAll = reviewSection.querySelector('.rao-reviews--all-score');
        /* Title */
        if (reviewAverage || reviewAll) {
          if (reviewAverage) {
            reviewAverage.innerText = window.reviewAppData.average_score;
          }
          if (reviewAll) {
            reviewAll.innerText = window.reviewAppData.amount_of_reviews;
          }
        }

        if (reviewContainer) {
          const reviewAmount = reviewContainer.dataset.amount;
          const cards = reviewContainer.querySelectorAll('.rao-reviews--card');

          for (let i = 0; i < reviewAmount; i++) {
            if (actualReviews.reviews[i].total_score < 4) {
              cards[i].style.display = "none";
            }
            cards[i].querySelector('.rao-reviews--card-name').innerText = actualReviews.reviews[i].client.name;
            cards[i].querySelector('.rao-reviews--card-description').innerText = actualReviews.reviews[i].questions[0].value;
            if (cards[i].querySelector('.red-more--inner').getBoundingClientRect().height > cards[i].querySelector('.red-more--content').getBoundingClientRect().height) {
              cards[i].querySelector('.rao-reviews--card-description').innerHTML += '<span class="red-less">Lees minder.</span>';
              const newRedMore = cards[i].querySelector('red-more').cloneNode(true);
              cards[i].querySelector('.rao-reviews--card-upper').replaceChild(newRedMore, cards[i].querySelector('red-more'));
              cards[i].querySelector('.red-more').classList.remove('hidden');
            }
            cards[i].querySelector('.rao-reviews--stars').innerHTML = "";
            /* Full stars */
            for (let j = 0; j < parseInt(actualReviews.reviews[i].total_score); j++) {
              cards[i].querySelector('.rao-reviews--stars').innerHTML += cards[i].querySelector('.rao-reviews--stars').dataset.fullStar;
            }

            /* Decimal */
            const rest = parseFloat(actualReviews.reviews[i].total_score) - parseInt(actualReviews.reviews[i].total_score);
            if (rest != 0) {
              if (rest < 0.5) {
                cards[i].querySelector('.rao-reviews--stars').innerHTML += cards[i].querySelector('.rao-reviews--stars').dataset.emptyStar;
              } else if (rest == 0.5) {
                cards[i].querySelector('.rao-reviews--stars').innerHTML += cards[i].querySelector('.rao-reviews--stars').dataset.halfStar;
              } else {
                cards[i].querySelector('.rao-reviews--stars').innerHTML += cards[i].querySelector('.rao-reviews--stars').dataset.fullStar;
              }

              /* Empty stars */
              if (5 - parseInt(actualReviews.reviews[i].total_score) > 1) {
                for (let j = 0; j < 4 - parseInt(actualReviews.reviews[i].total_score); j++) {
                  cards[i].querySelector('.rao-reviews--stars').innerHTML += cards[i].querySelector('.rao-reviews--stars').dataset.emptyStar;
                }
              }
            }
            if (actualReviews.reviews[i].recommends == "Ja") {
              cards[i].querySelector('.rao-reviews--card-recommends').innerText = "Beveelt Solfelt aan";
            }
          }
          reviewContainer.classList.add('active');
        }
        /* Apply slider */
        const inspirationSlider = reviewSection.querySelector('.pre-inspiration-slider');
        if (inspirationSlider) {
          const html = inspirationSlider.innerHTML;

          const newContainer = document.createElement('inspiration-slider');
          newContainer.dataset.infiniteScroll = "";
          newContainer.dataset.align = "center";
          newContainer.dataset.gap = "15";
          newContainer.innerHTML = html;
          inspirationSlider.after(newContainer);
          inspirationSlider.remove();
        }
      }
    }
  }.bind(this));
});


/* Feedback Review Bar */
window.addEventListener('access-granted', async function() {
  const raoReviewBars = document.querySelectorAll('rao-review-bar');

  class RaoReviewBar extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const starContainer = this.querySelector('.review-bar--stars');
      const fullStar = starContainer.dataset.fullStar;
      const halfStar = starContainer.dataset.halfStar;
      const emptyStar = starContainer.dataset.emptyStar;
      const currentRatingAmount = this.querySelector('.review-bar--current-rating');
      const allRatingAmount = this.querySelector('.review-bar--all-ratings');
  
      if(starContainer && fullStar && halfStar && emptyStar && currentRatingAmount && allRatingAmount) {
        const appData = window.reviewAppData;
  
        this.calculateStars(starContainer, fullStar, halfStar, emptyStar, appData.average_score / 2);
        this.parseAmounts(currentRatingAmount, allRatingAmount, appData);
  
        this.classList.add('active');
      }
      else {
        console.log("ERR: Data missing");
      }
    }
  
    parseAmounts(currentRatingAmount, allRatingAmount, appData) {
      currentRatingAmount.innerText = appData.average_score;
      allRatingAmount.innerText = appData.amount_of_reviews + " reviews";
    }
  
    calculateStars(starContainer, fullStar, halfStar, emptyStar, score) {
      /* Full stars */
      for(let i = 0; i < parseInt(score); i++) {
        starContainer.innerHTML += fullStar;
      }
  
      /* Decimal */
      const rest = score - parseInt(score);
      if(rest < 0.5) {
        starContainer.innerHTML += emptyStar;
      }
      else if(rest == 0.5) {
        starContainer.innerHTML += halfStar;
      }
      else {
        starContainer.innerHTML += fullStar;
      }
  
      /* Empty stars */
      if(5 - parseInt(score) > 1) {
        for(let i = 0; i < 4 - parseInt(score); i++) {
          starContainer.innerHTML += emptyStar;
        }
      }
    }
  }
  
  customElements.define('rao-review-bar', RaoReviewBar);
});

/* Product Page Specs On Variant Change */
document.addEventListener('variant:change', function(e) {
  const specItems = document.querySelectorAll('.product-information__specifications--content');
  if(specItems.length > 2) {
    const newVariantId = e.detail.variant.id;
    const prevVariantId = e.detail.previousVariant.id;
    const prevElement = document.querySelectorAll(`[data-variant-id="${prevVariantId}"]`);
    const newElement = document.querySelectorAll(`[data-variant-id="${newVariantId}"]`);
    prevElement[0].classList.add('hidden');
    prevElement[1].classList.add('hidden');
    newElement[0].classList.remove('hidden');
    newElement[1].classList.remove('hidden');
  }
});

/* RAO Shop The Look */
window.addEventListener('click', function(e) {
  const buttons = document.querySelectorAll('.rao-shop--hotspot-product');
  if(!(e.target.classList.contains('shop-the-look__hot-spot'))) {
    for(const button of buttons) {
      button.classList.remove('open');
      button.parentElement.classList.remove('open');
    }
  }
});

/* RAO Hotspot */
class RAOHotspot extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const container = this.parentElement;
    const button = this.querySelector('.shop-the-look__hot-spot');
    const product = this.querySelector('.hero--hotspot-product');

    if(container && button && product) {
      button.addEventListener('click', function() {
        if(product.classList.contains("open")) {
          product.classList.remove("open");
          product.parentElement.classList.remove('open');
        }
        else {
          this.positionProduct(container, button, product);
        }
      }.bind(this));
    }
    else {
      console.log("ERR: Elements Missing");
    }
  }

  positionProduct(container, button, product) {
    /* Close the other items */
    const otherItems = this.parentElement.querySelectorAll('.hero--hotspot-product.open');
    for(const item of otherItems) {
      item.classList.remove('open');
      item.parentElement.classList.remove('open');
    }
    
    /* Get Element Data */
    const containerData = container.getBoundingClientRect();
    const productData = product.getBoundingClientRect();
    const buttonData = button.getBoundingClientRect();
    
    /* Check if the product fits below the hotspot */
    if(containerData.top + containerData.height > buttonData.top + buttonData.height + 26 + productData.height) {
      product.classList.add("bottom");
    }
    else {
      product.classList.add("top");
    }

    /* Check if the product fits middle to the hotspot horizontally */
    if((containerData.left < buttonData.left + buttonData.width / 2 - productData.width / 2) && (containerData.right > buttonData.left + buttonData.width / 2 + productData.width / 2)) {
      product.classList.add("middle");
    }
    else if(containerData.left > buttonData.left + buttonData.width / 2 - productData.width) {
      /* Check if the product fits left to the hotspot horizontally */
      product.classList.add("left");
    }
    else if(containerData.right < buttonData.left + buttonData.width / 2 + productData.width) {
      /* Check if the product fits right to the hotspot horizontally */
      product.classList.add("right");
    }

    product.classList.add("open");
    product.parentElement.classList.add('open');
  }
}

customElements.define('rao-hotspot', RAOHotspot);

/* RAO Filter Block */
class RAOFilterBlock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const rowAmount = this.dataset.itemAmountShown ? parseInt(this.dataset.itemAmountShown) : -1;
    const useSearch = this.dataset.useSearch;
    
    if(rowAmount != -1 || useSearch) {
      const content = this.querySelector('.filter-accordion');
      const inner = this.querySelector('.filter-accordion--inner');
      this.items = this.querySelectorAll('.filter-accordion--inner > *:not(.search-hidden)');
      const button = this.querySelector('.filter-accordion--button');

      if(content && inner && this.items.length != 0 && button) {
        if(button && !(button.classList.contains('set'))) {
          button.addEventListener('click', function() {
            if(this.classList.contains('open')) {
              this.close(button);
            }
            else {
              this.open(content, inner, button);
            }
          }.bind(this));
          button.classList.add('set');
        }
      
        this.checkAccordion(content, inner, rowAmount);
      }

      /* Search */
      if(useSearch) {
        const searchInput = this.querySelector('.filter-search--input');
        if(searchInput) {
          const input = this.querySelector('[contenteditable]');
          const labels = this.items;
          //const labels = this.querySelectorAll('.filter-accordion--inner label');
          let enter = false;

          input.addEventListener('keydown', function(e) {
            if(e.key == "Enter") {
              enter = true;
            }
            else {
              enter = false;
            }
          });

          input.addEventListener('beforeinput', function(e) {
            if(enter) {
              e.preventDefault();
            }
          });

          input.addEventListener('input', function() {
            for(const label of labels) {
              if(label.textContent.toLowerCase().includes(input.textContent.toLowerCase())) {
                label.classList.remove('search-hidden');
              }
              else {
                label.classList.add('search-hidden');
              }
              this.checkAccordion(content, inner, rowAmount);
              this.close(button);
            }
          }.bind(this));
        }
      }
    }
  }

  checkAccordion(content, inner, rowAmount) {
    this.items = this.querySelectorAll('.filter-accordion--inner > *:not(.search-hidden)');

    if(this.items.length > rowAmount) {
      this.initAccordion(content, inner, rowAmount);

      window.addEventListener('resize', function() {
        this.initAccordion(content, inner, rowAmount);
      }.bind(this));
    }
    else {
      this.stopAccordion(content, inner);
    }
  }

  initAccordion(content, inner, rowAmount) {
    let contentHeight = 0;
    /* Get Content Height */
    for(let i = 0; i < rowAmount; i++) {
      contentHeight += this.items[i].getBoundingClientRect().height;
    }

    content.style.setProperty('--content-height', contentHeight + 'px');
    content.style.setProperty('--inner-height', inner.getBoundingClientRect().height + 'px');
    this.classList.add('active');
  }

  stopAccordion(content, inner) {
    content.style.setProperty('--inner-height', inner.getBoundingClientRect().height + 'px');
    this.classList.remove('active');
  }

  open(content, inner, button) {
    content.style.setProperty('--inner-height', inner.getBoundingClientRect().height + 'px');
    this.classList.add('open');
    button.firstChild.textContent = button.dataset.collapseText;
  }

  close(button) {
    this.classList.remove('open');
    button.firstChild.textContent = button.dataset.openText;
  }
}

customElements.define('rao-filter-block', RAOFilterBlock);

/* Thumbnail Accordion */
class ThumbnailAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttonTexts = this.querySelectorAll('.thumbnail-accordion--text');

    if(this.buttonTexts.length > 0) {
      this.inner = this.querySelector('.thumbnail-accordion--inner');
      this.showLess = this.querySelector('.thumbnail-accordion--show-less');
      this.getHeight();

      for(const button of this.buttonTexts) {
        button.parentElement.addEventListener('click', function() {
          if(!(this.classList.contains('open'))) {
            this.open();
          }
        }.bind(this));
      }

      if(this.showLess) {
        this.showLess.addEventListener('click', function() {
          this.close();
        }.bind(this));
      }
    }
  }

  getHeight() {
    this.contentHeight = this.inner.getBoundingClientRect().height;
    this.style.setProperty('--closed-height', this.contentHeight + 'px');
    this.classList.add('active');
  }

  open() {
    this.contentHeight = this.inner.getBoundingClientRect().height;
    this.style.setProperty('--opened-height', this.contentHeight + 'px');
    this.classList.add('open');
  }

  close() {
    this.classList.remove('open');
  }
}

customElements.define('thumbnail-accordion', ThumbnailAccordion);

/* Spec Accordion */
class SpecAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.breakpoint = this.dataset.breakpoint;
    
    this.desktopContent = this.querySelector('.spec__content--desktop');
    this.desktopInner = this.querySelector('.spec__inner--desktop');
    this.desktopButton = this.querySelector('.spec--button-desktop');

    if(this.desktopContent && this.desktopInner && this.desktopButton) {
      this.desktopButton.addEventListener('click', function() {
        if(this.classList.contains('open')) {
          this.close();
        }
        else {
          this.open(this.desktopContent, this.desktopInner);
        }
      }.bind(this));
    }

    this.mobileContent = this.querySelector('.spec__content--mobile');
    this.mobileInner = this.querySelector('.spec__inner--mobile');
    this.mobileButton = this.querySelector('.spec--button-mobile');

    if(this.mobileContent && this.mobileInner && this.mobileButton) {
      this.mobileButton.addEventListener('click', function() {
        if(this.classList.contains('open')) {
          this.close();
        }
        else {
          this.open(this.mobileContent, this.mobileInner);
        }
      }.bind(this));
    }

    window.addEventListener('resize', function() {
      this.close();
    }.bind(this));
  }

  open(content, inner) {
    content.style.setProperty('--inner-height', inner.getBoundingClientRect().height + 'px');
    this.classList.add('open');
  }

  close() {
    this.classList.remove('open');
  }
}

customElements.define('spec-accordion', SpecAccordion);

/* RAO Product Accordion */
class RAOProductAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('.product-accordion--button');
    this.dropdown = this.querySelector('.product-accordion--dropdown');
    this.inner = this.dropdown.querySelector('.product-accordion--inner');

    this.getInnerHeight();

    window.addEventListener('resize', function() {
      this.getInnerHeight();
    }.bind(this));

    this.button.addEventListener('click', function() {
      this.getInnerHeight();
      this.classList.toggle('open');
      this.classList.toggle('open-mobile');
    }.bind(this));
  }

  getInnerHeight() {
    this.dropdown.style.setProperty('--inner-height', this.inner.getBoundingClientRect().height + 'px');
  }
}

customElements.define('rao-product-accordion', RAOProductAccordion);

/* Quantity Selector */
class RAOQuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.select = this.querySelector('.product__quantity--input');
    this.selectText = this.select.querySelector('.product__quantity--select');
    this.input = this.select.querySelector('input');
    this.dropdown = this.querySelector('.product__quantity--dropdown');
    this.inner = this.dropdown.querySelector('.product__quantity--inner');
    this.items = this.inner.querySelectorAll('.product__quantity--item');

    this.select.addEventListener('click', function() {
      this.dropdown.style.setProperty('--inner-height', this.inner.getBoundingClientRect().height + 'px');
      if(this.classList.contains('open')) {
        this.close();
      }
      else {
        this.checkPosition();
        this.open()
      }
    }.bind(this));

    for(const item of this.items) {
      item.addEventListener('click', function() {
        this.inner.querySelector('.is-selected').classList.remove('is-selected');
        item.classList.add('is-selected');
        this.selectText.innerText = item.innerText;
        this.input.value = item.innerText;
        this.close();
      }.bind(this));
    }

    document.body.addEventListener('click', function(e) {
      if(!(this.select.contains(e.target))) {
        this.close();
      }
    }.bind(this));
  }

  close() {
    this.classList.remove('open');
  }

  open() {
    this.classList.add('open');
  }

  checkPosition() {
    if(this.inner.getBoundingClientRect().top + this.inner.getBoundingClientRect().height > window.innerHeight) {
      //this.classList.add('open-to-top');
    } else {
      this.classList.remove('open-to-top');
    }
  }
}

customElements.define('rao-quantity-selector', RAOQuantitySelector);

/* Hero Section Slider */
class HeroSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.blocks = this.querySelectorAll('.hero-slider--block');
    this.nextButtons = this.querySelectorAll('.hero-slider--next');
    this.previousButtons = this.querySelectorAll('.hero-slider--previous');
    this.enableAutoplay = this.dataset.autoplay;
    this.autoplayDelayTime = parseInt(this.dataset.autoplayDelay) * 1000;

    if(this.blocks.length > 1 && this.nextButtons.length > 0 && this.previousButtons.length > 0) {
      this.transformAmount = this.blocks.length;
      this.tripleBlocks();
      this.setupEvents();
      setTimeout(function() {
        this.classList.add('active');
      }.bind(this), 500);

      if(this.enableAutoplay === "true") {
        this.setupAutoplay();

        this.addEventListener('mouseover', function() {
          this.mouseOver = true;
          clearInterval(this.autoplayInterval);
        }.bind(this));

        this.addEventListener('mouseout', function() {
          if(this.mouseOver) {
            this.mouseOver = false;
            this.setupAutoplay();
          }
        }.bind(this));
      }
    }
  }

  tripleBlocks() {
    for(const block of this.blocks) {
      let tempBlock = block.cloneNode(true);
      this.insertBefore(tempBlock, this.blocks[0]);
      tempBlock = block.cloneNode(true);
      this.appendChild(tempBlock);
    }

    this.style.setProperty('--transform-amount', `-${this.transformAmount * 100}%`);
    this.blocks = this.querySelectorAll('.hero-slider--block');
    this.nextButtons = this.querySelectorAll('.hero-slider--next');
    this.previousButtons = this.querySelectorAll('.hero-slider--previous');
  }

  setupEvents() {
    for(const nextButton of this.nextButtons) {
      this.setupNextEvent(nextButton);
    }

    for(const previousButton of this.previousButtons) {
      this.setupPreviousEvent(previousButton);
    }
  }

  setupNextEvent(element) {
    element.addEventListener('click', function() {
      this.nextFunction();
    }.bind(this));
  }

  nextFunction() {
    if(this.blocks[3].querySelector('red-more')) {
      this.blocks[3].querySelector('red-more').classList.remove('open');
    }
    this.classList.add('moving');
    this.transformAmount += 1;
    this.style.setProperty('--transform-amount', `-${this.transformAmount * 100}%`);
    setTimeout(function() {
      this.classList.remove('moving');
      //this.blocks[0].querySelector('.review-bar--stars').innerHTML = "";
      const tempBlock = this.blocks[0].cloneNode(true);
      this.appendChild(tempBlock);

      this.blocks[0].remove();
      this.transformAmount -= 1;
      this.style.setProperty('--transform-amount', `-${this.transformAmount * 100}%`);

      this.blocks = this.querySelectorAll('.hero-slider--block');

      this.setupNextEvent(tempBlock.querySelector('.hero-slider--next'));
      this.setupPreviousEvent(tempBlock.querySelector('.hero-slider--previous'));
    }.bind(this), 500);
  }

  setupPreviousEvent(element) {
    element.addEventListener('click', function() {
      if(this.blocks[3].querySelector('red-more')) {
        this.blocks[3].querySelector('red-more').classList.remove('open');
      }
      this.classList.add('moving');
      this.transformAmount -= 1;
      this.style.setProperty('--transform-amount', `-${this.transformAmount * 100}%`);
      setTimeout(function() {
        this.classList.remove('moving');
        this.blocks[this.blocks.length - 1].querySelector('.review-bar--stars').innerHTML = "";
        const tempBlock = this.blocks[this.blocks.length - 1].cloneNode(true);
        this.insertBefore(tempBlock, this.firstElementChild);
        this.blocks[this.blocks.length - 1].remove();

        this.transformAmount += 1;
        this.style.setProperty('--transform-amount', `-${this.transformAmount * 100}%`);

        this.blocks = this.querySelectorAll('.hero-slider--block');

        this.setupPreviousEvent(tempBlock.querySelector('.hero-slider--previous'));
        this.setupNextEvent(tempBlock.querySelector('.hero-slider--next'));
      }.bind(this), 500);
    }.bind(this));
  }

  setupAutoplay() {
    this.autoplayInterval = setInterval(function() {
      this.nextFunction();
    }.bind(this), this.autoplayDelayTime);
  }
}

customElements.define('hero-slider', HeroSlider);

/* Red More */
class RedMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.inner = this.querySelector('.red-more--inner');
    this.lineHeight = this.dataset.lineHeight;
    this.lineAmount = this.dataset.lineAmount;
    this.redMore = this.querySelector('.red-more');
    this.redLess = this.querySelector('.red-less');
    this.checkDevice = this.dataset.mobileLineAmount ? true : false;
    this.dynamic = this.dataset.lineDynamic ? true : false;

    if(this.dynamic) {
      this.dynamicContainer = document.querySelector("#" + this.dataset.id);
      this.dynamicHeightContainer = this.dynamicContainer.querySelector('.red-more--dynamic');
      
      if(this.dynamicContainer && this.dynamicHeightContainer) {
        
        this.dynamicMinuses = this.dynamicContainer.querySelectorAll('.red-more__dynamic--minus');
        let dynamicMinusAmount = 0;
        for(const dynamicMinus of this.dynamicMinuses) {
          dynamicMinusAmount += dynamicMinus.getBoundingClientRect().height;
        }
        const dynamicHeight = this.dynamicHeightContainer.getBoundingClientRect().height - dynamicMinusAmount;
        const newLineAmount = Math.round(dynamicHeight / parseInt(this.lineHeight));

        this.lineAmount = newLineAmount
        this.style.setProperty('--line-amount', newLineAmount);
      }
    }

    if(this.checkDevice) {
      this.mobileLineAmount = this.dataset.mobileLineAmount;
      this.mobileLineHeight = this.dataset.mobileLineHeight ? this.dataset.mobileLineHeight : this.lineHeight;
    }
    
    if(this.inner && this.lineHeight && this.lineAmount && this.redMore && this.redLess) {
      if(this.checkHeight()) {
        this.setup();
      }
      else {
        this.redMore.style.display = "none"; 
        this.redLess.style.display = "none";
      }

      window.addEventListener('resize', function() {
        if(this.dynamic) {
          let dynamicMinusAmount = 0;
          for(const dynamicMinus of this.dynamicMinuses) {
            dynamicMinusAmount += dynamicMinus.getBoundingClientRect().height;
          }
          const dynamicHeight = this.dynamicHeightContainer.getBoundingClientRect().height - dynamicMinusAmount;
          const newLineAmount = Math.round(dynamicHeight / parseInt(this.lineHeight));

          this.lineAmount = newLineAmount
          this.style.setProperty('--line-amount', newLineAmount);
        }

        this.style.setProperty('--max-height', this.inner.getBoundingClientRect().height + 'px');
        if(this.checkHeight) {
          this.setup();
        }
        else {
          this.redMore.style.display = "none";
          this.redLess.style.display = "none";
        }
      }.bind(this));
    }
  }

  checkHeight() {
    if(this.checkDevice) {
      if(window.innerWidth < 700) {
        if(this.inner.getBoundingClientRect().height > parseInt(this.mobileLineHeight) * parseInt(this.mobileLineAmount)) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        if(this.inner.getBoundingClientRect().height > parseInt(this.lineHeight) * parseInt(this.lineAmount)) {
          return true;
        }
        else {
          return false;
        }
      }
    }
    else {
      if(this.inner.getBoundingClientRect().height > parseInt(this.lineHeight) * parseInt(this.lineAmount)) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  setup() {
    this.redMore.addEventListener('click', function() {
      this.style.setProperty('--max-height', this.inner.getBoundingClientRect().height + parseInt(this.lineHeight) + 'px');
      this.classList.add('open');
    }.bind(this));

    this.redLess.addEventListener('click', function() {
      this.classList.remove('open');
    }.bind(this));
  }
}

customElements.define('red-more', RedMore);

/* FAQ accordion */
class RAOAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('.rao-accordion--button');
    this.content = this.querySelector('.rao-accordion--content');
    this.inner = this.querySelector('.rao-accordion--inner');

    this.clickableItems = this.querySelectorAll('rao-contact-item');

    this.content.style.setProperty('--answer-height', this.inner.getBoundingClientRect().height + 'px');

    if(!(this.button.classList.contains('set'))) {
      this.button.addEventListener('click', function() {
        this.accordionFunction();
      }.bind(this));
      this.button.classList.add('set');
    }

    if(this.clickableItems && this.previousElementSibling && this.previousElementSibling.tagName == "INPUT") {
      for(const item of this.clickableItems) {
        item.addEventListener('click', function() {
          if(item.classList.contains('selected')) {
            this.button.querySelector('span').innerText = this.button.querySelector('span').dataset.initialText;
            this.previousElementSibling.value = ""
            item.classList.remove('selected');
            this.accordionFunction();
          }
          else {
            this.button.querySelector('span').innerText = item.innerText;
            this.previousElementSibling.value = item.innerText;
            if(this.querySelector('rao-contact-item.selected')) {
              this.querySelector('rao-contact-item.selected').classList.remove('selected');
            }
            item.classList.add('selected');
            this.accordionFunction();
          }
        }.bind(this));
      }
    }
  }

  accordionFunction() {
    this.classList.remove('auto');
    this.content.style.setProperty('--answer-height', this.inner.getBoundingClientRect().height + 'px');
    this.classList.toggle('open');
    setTimeout(function() {
      this.classList.add('auto');
    }.bind(this), 300);
  }
}

customElements.define('rao-accordion', RAOAccordion);

/* Dragger */
class RAOSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sliderContainer = this.firstElementChild;
    this.items = this.sliderContainer.children;

    this.checkItems();
  }

  checkItems() {
    this.lastItem = this.items[this.items.length - 1];
    if(this.lastItem.getBoundingClientRect().x + this.lastItem.getBoundingClientRect().width > this.getBoundingClientRect().width) {
      this.position = 0;
      this.moveAmount = 0;
      this.endMoveAmount = (-1) * (this.lastItem.getBoundingClientRect().x + this.lastItem.getBoundingClientRect().width - this.getBoundingClientRect().width);
      this.initSlider();
    }
  }

  initSlider() {
    this.classList.add('active');
    this.addEventListener('mousedown', function(e) {
      this.click = true;
      this.mouseDown = true;
      this.startX = e.clientX;
    }.bind(this));

    this.addEventListener('mousemove', function(e) {
      if(this.mouseDown) {
        this.click = false;
        this.moveAmount = e.clientX - this.startX;
        this.classList.add('moving');
        this.sliderContainer.style.setProperty('--move-amount', `${this.position + this.moveAmount}px`);
      }
    }.bind(this));

    this.addEventListener('click', function(e) {
      if(!(this.click)) {
        e.preventDefault();
      }
    }.bind(this));

    this.addEventListener('mouseup', function() {
      this.mouseDown = false;
      this.classList.remove('moving');
      this.position += this.moveAmount;

      if(this.position > 0) {
        this.position = 0;
        this.sliderContainer.style.setProperty('--move-amount', '0px');
      }
      if(this.position < this.endMoveAmount) {
        this.position = this.endMoveAmount;
        this.sliderContainer.style.setProperty('--move-amount', `${this.endMoveAmount}px`);
      }
    }.bind(this));

    this.addEventListener('mouseout', function(e) {
      console.log(e);
      this.mouseDown = false;
      this.classList.remove('moving');
      this.position += this.moveAmount;

      if(this.position > 0) {
        this.position = 0;
        this.sliderContainer.style.setProperty('--move-amount', '0px');
      }
      if(this.position < this.endMoveAmount) {
        this.position = this.endMoveAmount;
        this.sliderContainer.style.setProperty('--move-amount', `${this.endMoveAmount}px`);
      }
    }.bind(this));
  }
}

class Slider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('.rao-slider--container');
    this.items = this.container.querySelectorAll('.rao-slider--item');
    this.sliderInit = false
    this.moving = false;
    this.baseAmount = this.items[0].getBoundingClientRect().left;

    this.addEvents();

    this.checkIfInitSlider();
    window.addEventListener('resize', function() {
      this.checkIfInitSlider();
    }.bind(this));
  }

  checkIfInitSlider() {
    if(this.sliderInit) {
      if(this.getWidthOfItems() <= this.container.getBoundingClientRect().width) {
        this.sliderInit = false;
        this.removeSlider();
      }
    } else {
      if(this.getWidthOfItems() > this.container.getBoundingClientRect().width) {
        this.sliderInit = true;
        this.initSlider();
      }
    }
  }

  movingTimer() {
    this.timer = setTimeout(function() {
      this.classList.add('moving');
      this.moving = true;
    }.bind(this), 100)
  }

  initSlider() {
    this.classList.add('active');
    this.baseAmount = this.items[0].getBoundingClientRect().left;
  }

  removeSlider() {
    this.classList.remove('active');
    this.moving = false;
    this.moveAmount = 0;
  }

  addEvents() {
    this.addEventListener('mousedown', function(e) {
      if(this.sliderInit) {
        this.movingTimer();
        this.mouseDown = true;
        this.mouseDownX = e.clientX;
        this.mouseDownY = e.clientY;
  
        this.moveAmount = 0;
        if(this.container.style.getPropertyValue('--move-amount') != "") {
          this.moveAmount = parseInt(this.container.style.getPropertyValue('--move-amount').replace('"', '').replace('px', ''));
        }
      }
    }.bind(this));

    this.addEventListener('touchstart', function(e) {
      if(this.sliderInit) {
        this.movingTimer();
        this.mouseDown = true;
        this.mouseDownX = e.targetTouches[0].clientX;
  
        this.moveAmount = 0;
        if(this.container.style.getPropertyValue('--move-amount') != "") {
          this.moveAmount = parseInt(this.container.style.getPropertyValue('--move-amount').replace('"', '').replace('px', ''));
        }
      }
    }.bind(this));

    this.addEventListener('click', function(e) {
      if(e.target == this.target) {
        e.preventDefault();
      }
    });

    this.addEventListener('mouseup', function(e) {
      if(this.sliderInit) {
        if(this.moving) {
          this.target = e.target;
        }
        else {
          clearTimeout(this.timer);
        }
        this.moving = false;
        this.classList.remove('moving');
        this.mouseDown = false;
  
        this.stop();
      }
    }.bind(this));

    this.addEventListener('touchend', function(e) {
      if(this.sliderInit) {
        if(this.moving) {
          this.target = e.target;
        }
        else {
          clearTimeout(this.timer);
        }
        this.moving = false;
        this.classList.remove('moving');
        this.mouseDown = false;
  
        this.stop();
      }
    }.bind(this));

    this.addEventListener('mouseleave', function(e) {
      if(this.sliderInit) {
        if(this.moving) {
          /* Stop Moving */
          this.moving = false;
          this.classList.remove('moving');
          this.mouseDown = false;
    
          this.stop();
        }
      }
    });

    this.addEventListener('mousemove', function(e) {
      if(this.sliderInit) {
        if(this.moving) {
          this.container.style.setProperty('--move-amount', `${this.moveAmount + e.clientX - this.mouseDownX}px`);
        }
      }
    });

    this.addEventListener('touchmove', function(e) {
      if(this.sliderInit) {
        if(this.moving) {
          this.container.style.setProperty('--move-amount', `${this.moveAmount + e.targetTouches[0].clientX - this.mouseDownX}px`);
        }
      }
    });
  }

  stop() {
    let closestItem = this.items[0];
    let closestValue = 10000;

    for(const item of this.items) {
      if(Math.abs(item.getBoundingClientRect().left) < closestValue) {
        closestItem = item;
        closestValue = Math.abs(item.getBoundingClientRect().left);
      }
    }

    this.selectItem(closestItem);
  }

  selectItem(closestItem) {
    const currentMoveAmount = parseInt(this.container.style.getPropertyValue('--move-amount').replace('"', '').replace('px', ''));
    this.container.style.setProperty('--move-amount', `${currentMoveAmount + this.baseAmount - closestItem.getBoundingClientRect().left}px`);
    this.moveAmount = parseInt(this.container.style.getPropertyValue('--move-amount').replace('"', '').replace('px', ''));
  }

  getWidthOfItems() {
    let itemsWidth = 0.0;
    for(const item of this.items) {
      itemsWidth += item.getBoundingClientRect().width;
    }

    return itemsWidth;
  }
}

customElements.define("rao-slider", Slider);

/* Filter Search */
class FilterSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('[contenteditable]');
    this.labels = this.parentElement.querySelectorAll('.filter-accordion--inner label');

    this.input.addEventListener('input', function() {
      for(const label of this.labels) {
        if(label.textContent.toLowerCase().includes(this.input.textContent.toLowerCase())) {
          label.parentElement.style.display = "flex";
        }
        else {
          label.parentElement.style.display = "none";
        }
      }
    }.bind(this));
  }
}

customElements.define('filter-search', FilterSearch);

class FilterAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.inner = this.querySelector('.filter-accordion--inner');
  }
}

customElements.define('filter-accordion', FilterAccordion);

/* Collection Featured Image Change */

window.addEventListener('DOMContentLoaded', function() {
  const collectionContainer = document.querySelector('.collection__main .product-list');
  const imageChangerContainer = document.querySelectorAll('.collection--toolbar__images-changer');
  for(const imageChanger of imageChangerContainer) {
    if(collectionContainer) {
      const sfeerfoto = imageChanger.querySelector('.collection--toolbar__sfeerfoto');
      const productfoto = imageChanger.querySelector('.collection--toolbar__productfoto');
      if(sfeerfoto && productfoto) {
        sfeerfoto.addEventListener('click', function() {
          productfoto.classList.remove('active');
          sfeerfoto.classList.add('active');
          collectionContainer.classList.add('product-list--sfeerfoto');
        });
  
        productfoto.addEventListener('click', function() {
          productfoto.classList.add('active');
          sfeerfoto.classList.remove('active');
          collectionContainer.classList.remove('product-list--sfeerfoto');
        });
      }
    }
  }
});

/* Collection Image layout change */
window.addEventListener('DOMContentLoaded', function() {
  const layoutChangerContainer = document.querySelector('.collection--toolbar__layout-changer');
  const productList = document.querySelector('.collection .product-list');
  if(layoutChangerContainer && productList) {
    const doubleLayoutButton = layoutChangerContainer.querySelector('.collection--toolbar__double');
    const singleLayoutButton = layoutChangerContainer.querySelector('.collection--toolbar__single');

    if(doubleLayoutButton && singleLayoutButton) {
      doubleLayoutButton.addEventListener('click', function() {
        doubleLayoutButton.classList.add('active');
        singleLayoutButton.classList.remove('active');
        productList.style.setProperty('--product-list-items-per-row', "2");
        productList.style.setProperty('--product-list-mobile-grid-end', "3");
      });
      singleLayoutButton.addEventListener('click', function() {
        singleLayoutButton.classList.add('active');
        doubleLayoutButton.classList.remove('active');
        productList.style.setProperty('--product-list-items-per-row', "1");
        productList.style.setProperty('--product-list-mobile-grid-end', "2");
      });
    }
  }
});

/* Mega Menu */

window.addEventListener('DOMContentLoaded', function() {
  const megaMenu = document.querySelector('.header__primary-nav--desktop .new-mega-menu');
  if (megaMenu) {
    const primaryItems = megaMenu.querySelectorAll('.new-mega-menu--primary-item');
    const secondaryItems = megaMenu.querySelectorAll('.new-mega-menu--secondary-blocks');
    if (primaryItems && secondaryItems) {
      for (let i = 0; i < primaryItems.length; i++) {
        primaryItems[i].addEventListener('mouseenter', function() {
          megaMenu.querySelector('.new-mega-menu--primary-item.active').classList.remove('active');
          primaryItems[i].classList.add('active');
          megaMenu.querySelector('.new-mega-menu--secondary-blocks.active').classList.remove('active');
          secondaryItems[i].classList.add('active');
        });
      }
    }
  }
});




/* Came With Theme */
/* --- Cart Upsell --- */
var CartUpsell = class extends HTMLElement {
  constructor() {
    super();

    this.dynamicProduct = this.getAttribute('data-preload');
    this.maxProducts = this.getAttribute('data-limit') || 10;

    if (this.dynamicProduct !== null) {
      this.init();
    }
  }

  async init() {
    const recommendations = 
      await fetch(`${ window.Shopify.routes.root }recommendations/products?product_id=${ this.dynamicProduct }&section_id=cart-upsell&limit=${ this.maxProducts }`)
        .then(response => response.text())
        .then(data => {
          return data;
        });

    const html = new DOMParser().parseFromString(recommendations, 'text/html');
    const target = html.querySelector('[data-dynamic-content]:not([hidden])');

    if (target) {
      this.innerHTML = target?.innerHTML;
      this.removeAttribute('data-preload');
      this.classList.remove('hidden');
    }
  }
}

window.customElements.define('cart-upsell', CartUpsell);

/* --- Extended search --- */
var PredictiveSearchEmptyState = class extends HTMLElement {
  constructor() {
    super();

    this.recentSearchesContainer = this.querySelector('.predictive-search__recent-searches');

    if (this.recentSearchesContainer) {
      this.renderContents();
    }
  }

  renderContents() {
    const container = this.recentSearchesContainer.querySelector('#recent-searches');
    const iconContainer = this.querySelector('#predictive-search-icons');
    const icons = {
      query: iconContainer.querySelector('.icon-predictive-search-query').outerHTML,
      product: iconContainer.querySelector('.icon-predictive-search-product').outerHTML,
      article: iconContainer.querySelector('.icon-predictive-search-article').outerHTML,
      collection: iconContainer.querySelector('.icon-predictive-search-collection').outerHTML,
      page: iconContainer.querySelector('.icon-predictive-search-page').outerHTML
    }

    /* Remove the icons element from DOM for cleanup */
    iconContainer.remove();

    /* Render recent searches */
    const recentSearches = window.recentSearches || [];
    const maxRecentSearches = window.themeVariables.settings.maxRecentSearch;
    const maxRecentSearchesMobile = window.themeVariables.settings.maxRecentSearchMobile;

    for (let i = 0; i < recentSearches.length; i++) {
      const recentSearch = recentSearches[i];
      const queryContainer = document.createElement('a');

      queryContainer.setAttribute('href', recentSearch.url);
      queryContainer.classList.add('predictive-search__recent-search', 'h-stack', 'gap-0.5');
      if (i >= maxRecentSearches) {
        queryContainer.classList.add('sm:hidden');
      }
      if (i >= maxRecentSearchesMobile) {
        queryContainer.classList.add('sm-max:hidden');
      }
      queryContainer.innerHTML = `
        <span>${ icons[recentSearch.type] }</span>
        <span class="link">${ recentSearch.title }</span>
      `;

      container.appendChild(queryContainer);
    }

    if (container.children.length > 0) {
      this.recentSearchesContainer.removeAttribute('hidden');
      this.parentNode.removeAttribute('hidden');
    }
  }
}

window.customElements.define('predictive-search-empty-state', PredictiveSearchEmptyState);

/* --- Clear recent searches button --- */
var ClearRecentSearches = class extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => this.clearRecentSearches());
  }

  clearRecentSearches() {
    window.recentSearches = [];
    localStorage.removeItem('recent-searches');

    this.closest('.predictive-search__recent-searches').setAttribute('hidden', '');

    const popularSearches = this.closest('.predictive-search__recent-searches').previousElementSibling;
    if (!popularSearches) {
      this.closest('predictive-search-empty-state').setAttribute('hidden', '');
    }
  }
}

window.customElements.define('clear-recent-searches', ClearRecentSearches);

var CollectionLabely = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const jsonData = this.querySelector('script[type="application/json"]');

    if (!jsonData) {
      return;
    }

    const json = JSON.parse(jsonData.innerText);

    fetch(`/apps/stocktime/api/rules`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(json)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Labely could not fetch collection data');
        }

        return response.json();
      })
      .then(data => {
        for (const item of data) {
          const targets = document.querySelectorAll(`.${item.target}`);

          if (targets.length === 0) {
            continue;
          }

          let displayIcon = 'none';
          let displayIconTop = 'none';

          if (item.icon && item.icon !== '') {
            displayIcon = 'inline-block';
          }

          if (item.iconTop && item.iconTop !== '') {
            displayIconTop = 'inline-block';
          }

          // Decode textTop and text
          const decodedTextTop = decodeURIComponent(item.textTop || '').replace(/\+/g, ' ');
          const decodedText = decodeURIComponent(item.text || '').replace(/\+/g, ' ');

          for (const target of targets) {
            target.innerHTML = `
              <div style="display: flex; margin:0; padding:0; flex-direction: column;">
                <div class="top" style="${item.styleTop} margin: 0; padding: 0; display: flex; align-items: flex-end;">
                  <span style="display: ${displayIconTop}; width: ${item.iconSizeTop}px; margin: 0; padding: 0; height: ${item.iconSizeTop}px; background-image: url(${item.iconTop}); background-position: center; background-size: contain; background-repeat: no-repeat;"></span>
                  <span style="display: flex; margin:0; padding:0;">${decodedTextTop}</span>
                </div>
                <div class="bottom" style="${item.style} margin: 0; padding: 0; display:flex; align-items: center;">
                  <span style="display: ${displayIcon}; margin: 0; padding: 0; width: ${item.iconSize}px; height: ${item.iconSize}px; background-image: url(${item.icon}); background-position: center; background-size: contain; background-repeat: no-repeat;"></span>
                  <span style="display: flex; margin: 0; padding: 0;">${decodedText}</span>
                </div>
              </div>
            `;
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
};


window.customElements.define('collection-labely', CollectionLabely);
